var React = require("react");
var Icon = require('infl-icons').Icon;
var { withNamespaces } = require('react-i18next');
var classnames = require('classnames');

const PointsIcon = () =>
  <svg
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 500 500"
    style={{width: 16}}>
    <title>Points</title>
    <path d="M312.5,166.7c-80.5,0-145.8,65.3-145.8,145.8S232,458.3,312.5,458.3c80.5,0,145.8-65.3,145.8-145.8S393,166.7,312.5,166.7 z M365.1,322.1l-25,13.7c-1.8,1-3.3,2.5-4.3,4.3l-13.7,25c-4.1,7.6-15,7.6-19.1,0l-13.7-25c-1-1.8-2.5-3.3-4.3-4.3l-25-13.7 c-7.6-4.1-7.6-15,0-19.1l25-13.7c1.8-1,3.3-2.5,4.3-4.3l13.7-25c4.1-7.6,15-7.6,19.1,0l13.7,25c1,1.8,2.5,3.3,4.3,4.3l25,13.7 C372.7,307.1,372.7,317.9,365.1,322.1z"></path>
    <path d="M168.1,193c35.8-43.2,88.4-68,144.5-68c2.3,0,4.5,0.2,6.8,0.3C299.9,84.2,261.6,53,216,44.4 C113.3,24.9,24.9,113.3,44.4,216.1c8.7,45.6,39.9,83.9,81.1,103.3C123.9,273.4,138.6,228.5,168.1,193z" data-element="path" data-source-file="coins.tsx"></path>
  </svg>;

var ChallengeCardPoints = React.createClass({
  PropTypes: {
    points: React.PropTypes.number,
    shortCardDesignEnabled: React.PropTypes.bool,
    rewriteLook: React.PropTypes.bool
  },
  render: function() {
    return (
      <span className={classnames({
        "card-points challenge-card__points": true,
        "challenge-card__points_old": !this.props.shortCardDesignEnabled,
        "challenge-card__points__rewrite": this.props.rewriteLook
      })}>

      {this.props.rewriteLook
        ? <PointsIcon />
        : <Icon icon="coins" title={this.props.t('Points')}/>}
        {this.props.points}
      </span>
    );
  }
});

module.exports = withNamespaces()(ChallengeCardPoints);



// WEBPACK FOOTER //
// ./src/advocate/challenges/components/challenge_card_points.jsx